<template>
  <div class="imgexhibite">
  
    <div class="mask" :style="maskSty" >
		<div :style="imgSty">
			<img
			id='img'
			class="imgcenter"
			:src="imgurl"
			alt=""
			/>
			<div class="skip" @click="closeheadle">跳过{{count}}</div>
		</div>
	</div>
   <!-- {{imgH}} -->
  </div>
</template>

<script>
export default {
  name: "imgexhibite",
  props:['maskimg'],
  computed:{
	  imgurl:function(){
		  return this.maskimg||''//require("../assets/img/swiper1.png")
	  },
	  maskSty:function(){ 
		return `height:calc(${this.imgH}px); transition:height 1s linear;`
		//   return `height:calc(${100-this.hNum}vh); transition:height ${Number(100/this.oldCount).toFixed(2)}s linear;`
	  },
	  imgSty:function(){ 
		  return `width:100%;position: relative;top:0px;`// -${this.hNum}vh
	  }
  },
  data: function() {
    return {
		timer:null,
		oldCount:5,
		count:5,
		hNum:100,
		imgH:0
    };
  },
  
  mounted(){
	  this.getDome()
	  
  },
  
  methods:{
	  setImgH(num){
		  this.imgH=num;
	  },
	  getDome(){
		  this.imgH=document.getElementById('img').offsetHeight;
		  setTimeout(()=>{ 
			  this.getCode()
		  },1000)
	  },
		getCode() {
		    this.timer = setInterval(()=>{
				// this.hNum=Number(this.count*(this.imgH/this.oldCount)).toFixed(2);//100-
		        this.count--;
		        if(this.count===0){
					this.closeheadle()
		        }
		    },1000)
		},
		
		closeheadle(){
			this.setImgH(0);
			setTimeout(()=>{ 
				this.$emit('showheadle');
				clearInterval(this.timer)
			},1000)
		},
		
		
  },
  
};
</script>

<style scoped="scoped" lang="scss">
.imgexhibite,.w-100{
	width: 100%;
}	

.mask {
	width: 100%;
	max-width: 100vw;
	height: 100vh;
	overflow: hidden;
//   position: fixed;
	position: relative;
	left: 0;
	z-index: 100;
	display: flex;
	justify-content: center;
	align-items: flex-end;
	
}
.imgcenter{
	width: 100%;
	height: 100vh;
	// position: absolute;
	// z-index: 101;
	// bottom: 0px;
}
.skip{
	position: absolute;
	right: 40px;
	top: 40px;
	font-size: 20px;
	color: #fff;
	cursor: pointer;
	// z-index: 102;
}
</style>
